/**
 * Trident favourites — localStorage list, tile star toggles, fly-to-header animation.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tt-favourites-v1';
  var EVT = 'tt:favourites-change';

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    window.dispatchEvent(new CustomEvent(EVT, { detail: { list: list } }));
  }

  function findIndex(list, id) {
    var sid = String(id);
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === sid) return i;
    }
    return -1;
  }

  function isFavourited(id) {
    return findIndex(readList(), id) >= 0;
  }

  function cardPayload(card) {
    var img = card.querySelector('.tt-tile-card__img:not(.is-deferred), .tt-tile-card__img[src]');
    var dataImage = card.getAttribute('data-tt-product-image') || '';
    var liveImage = '';
    if (img) {
      liveImage = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-tt-src') || '';
    }
    return {
      id: String(card.getAttribute('data-tt-product-id') || ''),
      handle: card.getAttribute('data-tt-product-handle') || '',
      title: card.getAttribute('data-tt-product-title') || '',
      url: card.getAttribute('data-tt-product-url') || '',
      image: dataImage || liveImage || '',
      addedAt: Date.now()
    };
  }

  function updateToggle(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-favourited', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var card = btn.closest('[data-tt-product]');
    var title = card ? card.getAttribute('data-tt-product-title') || 'tile' : 'tile';
    btn.setAttribute('aria-label', on ? 'Remove ' + title + ' from favourites' : 'Add ' + title + ' to favourites');
  }

  function syncAllToggles(list) {
    document.querySelectorAll('[data-tt-favourite-toggle]').forEach(function (btn) {
      var card = btn.closest('[data-tt-product]');
      if (!card) return;
      var id = card.getAttribute('data-tt-product-id');
      updateToggle(btn, findIndex(list, id) >= 0);
    });
  }

  function syncBadge(list) {
    var count = list.length;
    document.querySelectorAll('[data-tt-favourites-count]').forEach(function (badge) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.classList.toggle('tt-hdr-icon__badge--empty', count < 1);
    });
    document.querySelectorAll('[data-tt-favourites-icon]').forEach(function (el) {
      el.classList.toggle('has-favourites', count > 0);
      var label = el.querySelector('[data-tt-favourites-label]');
      if (label) {
        label.textContent = count < 1 ? 'Favourites' : 'Favourites, ' + count + ' saved';
      }
    });
  }

  function pulseNav() {
    var target = document.querySelector('[data-tt-favourites-icon]');
    if (!target) return;
    target.classList.remove('is-fav-pulse');
    void target.offsetWidth;
    target.classList.add('is-fav-pulse');
    window.setTimeout(function () {
      target.classList.remove('is-fav-pulse');
    }, 700);
  }

  function flyToNav(card) {
    var target = document.querySelector('[data-tt-favourites-icon]');
    var img = card.querySelector('.tt-tile-card__img, .tt-tile-card__placeholder');
    if (!target || !img) {
      pulseNav();
      return;
    }

    var reduce =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      document.documentElement.classList.contains('tt-lite');
    if (reduce) {
      pulseNav();
      return;
    }

    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (from.width < 4 || to.width < 4) {
      pulseNav();
      return;
    }

    var clone = img.cloneNode(true);
    clone.classList.add('tt-fav-fly');
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.width = from.width + 'px';
    clone.style.height = from.height + 'px';
    clone.style.left = from.left + 'px';
    clone.style.top = from.top + 'px';
    document.body.appendChild(clone);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var scale = Math.max(0.12, Math.min(to.width / from.width, 0.22));

    requestAnimationFrame(function () {
      clone.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + scale + ')';
      clone.style.opacity = '0.35';
      clone.style.borderRadius = '50%';
    });

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      pulseNav();
    }

    clone.addEventListener('transitionend', finish);
    window.setTimeout(finish, 780);
  }

  function toggleFavourite(card, btn) {
    var payload = cardPayload(card);
    if (!payload.id) return;

    var list = readList();
    var idx = findIndex(list, payload.id);
    var adding = idx < 0;

    if (adding) {
      list.unshift(payload);
      writeList(list);
      updateToggle(btn, true);
      flyToNav(card);
    } else {
      list.splice(idx, 1);
      writeList(list);
      updateToggle(btn, false);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function drawerEl() {
    return document.getElementById('FavouritesDrawer');
  }

  function renderDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;
    var list = readList();
    var empty = drawer.querySelector('[data-tt-fav-empty]');
    var ul = drawer.querySelector('[data-tt-fav-list]');
    if (!ul) return;

    if (list.length < 1) {
      ul.innerHTML = '';
      ul.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    ul.hidden = false;
    ul.innerHTML = list
      .map(function (item) {
        var href = item.url || (item.handle ? rootPath() + 'products/' + encodeURIComponent(item.handle) : '#');
        var title = escapeHtml(item.title || 'Saved tile');
        var image = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="140" height="140">'
          : '';
        return (
          '<li class="tt-fav-drawer__item">' +
            '<a class="tt-fav-drawer__media" href="' + escapeHtml(href) + '">' + image + '</a>' +
            '<a class="tt-fav-drawer__title" href="' + escapeHtml(href) + '">' + title + '</a>' +
            '<button type="button" class="tt-fav-drawer__remove" data-tt-fav-remove="' + escapeHtml(item.id) + '">Remove</button>' +
          '</li>'
        );
      })
      .join('');
  }

  function closeDrawer() {
    var drawer = drawerEl();
    if (!drawer || !drawer.classList.contains('active')) return;
    drawer.classList.remove('active');
    var icon = document.querySelector('[data-tt-favourites-icon]');
    if (icon) icon.setAttribute('aria-expanded', 'false');
    if (!document.querySelector('cart-drawer.active')) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  function openDrawer(trigger) {
    var drawer = drawerEl();
    if (!drawer) return;
    var cart = document.querySelector('cart-drawer');
    if (cart && cart.classList.contains('active') && typeof cart.close === 'function') cart.close();
    renderDrawer();
    window.setTimeout(function () {
      drawer.classList.add('active');
    });
    document.body.classList.add('overflow-hidden');
    var panel = drawer.querySelector('.drawer__inner');
    if (panel) panel.focus();
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function onIconClick(event) {
    var icon = event.target.closest('[data-tt-favourites-icon]');
    if (!icon) return;
    event.preventDefault();
    var drawer = drawerEl();
    if (drawer && drawer.classList.contains('active')) closeDrawer();
    else openDrawer(icon);
  }

  function onDrawerClick(event) {
    if (event.target.closest('[data-tt-fav-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    var remove = event.target.closest('[data-tt-fav-remove]');
    if (!remove) return;
    event.preventDefault();
    var list = readList();
    var idx = findIndex(list, remove.getAttribute('data-tt-fav-remove'));
    if (idx < 0) return;
    list.splice(idx, 1);
    writeList(list);
  }

  function onKey(event) {
    if (event.code !== 'Escape') return;
    var drawer = drawerEl();
    if (drawer && drawer.classList.contains('active')) closeDrawer();
  }

  function onClick(event) {
    var btn = event.target.closest('[data-tt-favourite-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var card = btn.closest('[data-tt-product]');
    if (!card) return;
    toggleFavourite(card, btn);
  }

  function refresh() {
    var list = readList();
    syncBadge(list);
    syncAllToggles(list);
  }

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function resolveHandle(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle).replace(/^\/+|\/+$/g, '');
    var url = String(item.url || '');
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function fetchTileCardHtml(item) {
    var handle = resolveHandle(item);
    if (!handle) return Promise.resolve(null);

    var base = rootPath() + 'products/' + encodeURIComponent(handle);

    function parseCard(html) {
      if (!html) return null;
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      return wrap.querySelector('.tt-tile-card');
    }

    return fetch(base + '?view=card', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('view-card ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var card = parseCard(html);
        if (card) return card;
        // Fallback: Section Rendering API (HTML for one section)
        return fetch(base + '?section_id=tt-tile-card-embed', { credentials: 'same-origin' }).then(function (res) {
          if (!res.ok) throw new Error('section ' + res.status);
          return res.text();
        }).then(parseCard);
      })
      .catch(function () {
        return null;
      });
  }

  function initPage() {
    var root = document.querySelector('[data-tt-favourites-page]');
    if (!root) return;

    var grid = root.querySelector('[data-tt-favourites-grid]');
    var empty = root.querySelector('[data-tt-favourites-empty]');
    if (!grid) return;

    var renderToken = 0;

    function afterRender() {
      if (window.TTTileCard && typeof window.TTTileCard.initAll === 'function') {
        window.TTTileCard.initAll();
      }
      document.dispatchEvent(new CustomEvent('tt:tile-cards-updated'));
      refresh();
    }

    function render() {
      var token = ++renderToken;
      var list = readList();
      grid.innerHTML = '';

      if (list.length < 1) {
        if (empty) empty.hidden = false;
        grid.hidden = true;
        return;
      }

      if (empty) empty.hidden = true;
      grid.hidden = false;
      grid.setAttribute('aria-busy', 'true');

      Promise.all(
        list.map(function (item) {
          return fetchTileCardHtml(item).then(function (card) {
            return { item: item, card: card };
          });
        })
      ).then(function (results) {
        if (token !== renderToken) return;

        grid.innerHTML = '';
        var shown = 0;

        results.forEach(function (result) {
          if (!result.card) return;
          shown += 1;
          grid.appendChild(result.card);
        });

        if (shown < 1) {
          if (empty) {
            empty.hidden = false;
            var emptyCopy = empty.querySelector('p');
            if (emptyCopy && list.length > 0) {
              emptyCopy.textContent =
                'Couldn’t load your saved tiles right now. Refresh the page, or open a tile and star it again.';
            }
          }
          grid.hidden = true;
        } else {
          if (empty) empty.hidden = true;
          grid.hidden = false;
        }

        grid.removeAttribute('aria-busy');
        afterRender();
      });
    }

    render();
    window.addEventListener(EVT, render);
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('click', onIconClick);
  document.addEventListener('click', onDrawerClick);
  document.addEventListener('keydown', onKey);
  window.addEventListener(EVT, function (event) {
    var list = (event.detail && event.detail.list) || readList();
    syncBadge(list);
    syncAllToggles(list);
    if (drawerEl() && drawerEl().classList.contains('active')) renderDrawer();
  });

  function boot() {
    refresh();
    initPage();
    document.addEventListener('click', function (event) {
      if (event.target.closest('#cart-icon-bubble')) closeDrawer();
    }, true);
    var icon = document.querySelector('[data-tt-favourites-icon]');
    if (icon) {
      icon.setAttribute('role', 'button');
      icon.setAttribute('aria-haspopup', 'dialog');
      icon.setAttribute('aria-controls', 'FavouritesDrawer');
      icon.setAttribute('aria-expanded', 'false');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-sync when collection filters re-show cards
  document.addEventListener('shopify:section:load', refresh);

  window.TTFavourites = {
    read: readList,
    isFavourited: isFavourited,
    refresh: refresh
  };
})();
